






import { Component, Prop, Vue } from "vue-property-decorator";
import { EmailTypes } from "@/data/enums/emails";
import { INotificationTemplate } from "@/models/notifications";

@Component({
  components: {
    "emails-history-provider": () =>
      import("@/components/app/global/emailHistory/emailsHistoryProvider.vue"),
    "email-history-table": () =>
      import("@/components/app/global/emailHistory/emailHistoryTable.vue")
  }
})
export default class AdminAutomationActionEmailHistory extends Vue {
  // Props

  @Prop({ default: undefined })
  public templateId!: INotificationTemplate["id"];

  // Data

  public emailType = EmailTypes.BRAND;
}
